<template>
  <div class="my-8">
    <p class="text-sm">Don't forget to read our <a class="text-jblue whitespace-no-wrap border-b border-dotted border-jblue hover:text-jpink hover:border-solid hover:border-jpink" href="#" @click.prevent="showAllergens">allergy information</a></p>

    <div id="allergens" v-show="allergens" class="text-xs p-3 border-jblue border border-solid bg-jblue bg-opacity-25 mt-4 allergens" v-html="compiledMarkdown"></div>

  </div>
</template>

<script>
import marked from 'marked';
export default {
  computed: {
    compiledMarkdown: function () {
      return marked(this.$root.$data.images.allergens)
    },
  },
  data: () => ({
    allergens: false
  }),
  methods: {
    showAllergens() {
      if(this.allergens) {
        this.allergens = false;
      } else {
        this.allergens = true;
        setTimeout(() => this.$scrollTo(document.getElementById('allergens'), 1000, {offset: -50}), 500)
      } 
    }
  }
}
</script>


<style>
.allergens p {
  @apply mb-3 text-left;
}
</style>